<div class="panel">
  <div class="content">
    <ng-container [cdkPortalHost]="contentPortal"></ng-container>
  </div>
</div>
